/**
 * @typedef {Object} Hierarchy
 * @property {number} id
 * @property {string} name
 * @property {Host[]} [hosts]
 */

/**
 * @typedef {Object} Host
 * @property {number} id
 * @property {string} name
 * @property {boolean} active
 * @property {string | null} [strategy]
 * @property {SensorsEntity[] | null} [sensors]
 * @property {number | null} [backofficeId]
 * @property {boolean} external
 * @property {string} externalSecret
 * @property {SensorGroupsEntity[] | null} [sensorGroups]
 */

/**
 * @typedef {Object} SensorsEntity
 * @property {number} id
 * @property {string | null} [sensorName]
 * @property {string} appName
 * @property {string} sensorType
 * @property {number | null} [funnelId]
 * @property {boolean} ingredientInsights
 * @property {string | null} [installationName]
 * @property {string | null} [countryCode]
 * @property {number | null} [backofficeConfigId]
 */

/**
 * @typedef {Object} SensorGroupsEntity
 * @property {number} id
 * @property {string} sensorName
 * @property {string} sensorType
 * @property {boolean} ingredientInsights
 * @property {string} retailerType
 * @property {number[]} [retailerIds]
 */

/**
 * Need the next
 * @param {Object} param0
 * @param {string} param0.api_url
 * @param {number} param0.retailerId
 * @returns
 */
export async function getInstallations({
  api_url,
  retailerId,
  apikey,
  safetyCode,
  appName,
} = {}) {
  api_url = api_url || "";

  return fetch(api_url + "/retailer/secure/hierarchy", {
    headers: {
      apikey,
      safetyCode,
    },
  })
    .then((res) => res.json())
    .then((retailers) => {
      if (retailerId)
        return retailers.filter((retailer) => retailer.id === retailerId);
      return retailers;
    })
    .then((/** @type {Hierarchy[]} */ results) => {
      /** @type {Host[]} */
      var hosts = results.reduce(
        (array, retailer) => array.concat(retailer.hosts),
        []
      );
      /** @type {(SensorsEntity & {hostId:Host['id'], host:Host})[]} */
      const sensors = hosts.reduce(
        (array, host) =>
          array.concat(
            host.sensors
              ?.map((s) => ({ ...s, hostId: host.id, host }))
              .filter((sensor) => !appName || sensor.appName === appName) ?? []
          ),
        []
      );
      console.debug("[Sensors] sensors = ", sensors);
      return sensors ?? [];
    });
}
